import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  FilledInput,
  FormControl,
  InputLabel,
  makeStyles,
  Snackbar,
  Typography,
} from '@material-ui/core';
import Section from '../components/Section';
import PreFooter from '../components/PreFooter';
import Logo from '../components/Logo';
import { sendEmailResetPassword } from '../services/auth';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles({
  button: {
    borderRadius: 16,
    color: 'white',
    marginRight: 16,
    paddingLeft: 16,
    paddingRight: 16,
  },
  input: {
    color: '#FFF',
  },
  link: {
    '&:link': {
      textDecoration: 'none',
    },
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
  footer: {
    bottom: 0,
    position: 'fixed',
    width: '100%',
  },
});
const ResetPassword = () => {
  const { button, footer, input, link, loading } = useStyles();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const componentIsMounted = useRef(true);
  const [snackbar, setSnackbar] = useState<ISnackbar>({
    severity: undefined,
    open: false,
    message: '',
  });
  useEffect(() => {
    return () => {
      componentIsMounted.current = false;
    };
  }, []);
  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let error;
    setSubmitting(true);
    error = await sendEmailResetPassword(email);
    setSubmitting(false);
    if (error) {
      setSnackbar({ message: error, open: true, severity: 'error' });
    } else {
      setSnackbar({
        message: 'Successfully send email',
        open: true,
        severity: 'success',
      });
      setEmail('');
    }
  };
  return (
    <>
      <Container maxWidth='md'>
        <Section display='flex' flexDirection='column' alignItems='center'>
          <Box display='flex' justifyContent='center' mt={2} mb={4}>
            <Link to='/'>
              <Logo />
            </Link>
          </Box>
          <Box bgcolor='#564F70' borderRadius={8} px={4} pt={4} pb={4}>
            <Typography align='center'>ลืมรหัสผ่าน</Typography>
            <form onSubmit={submit}>
              <Box my={3} display='flex'>
                <FormControl variant='filled' fullWidth>
                  <InputLabel>Email</InputLabel>
                  <FilledInput
                    classes={{ root: input }}
                    value={email}
                    onChange={(e) => {
                      const { value } = e.target;
                      setEmail(value);
                    }}
                    required
                  />
                </FormControl>
              </Box>
              <Box my={3}>
                <Button
                  classes={{ root: button }}
                  variant='contained'
                  fullWidth
                  style={{ backgroundColor: '#7683F9' }}
                  type='submit'
                >
                  ยืนยัน
                </Button>
              </Box>
            </form>
          </Box>
          <Box mt={3} display='flex'>
            <Link className={link} to='/login'>
              <Typography color='secondary'>เข้าสู่ระบบ</Typography>
            </Link>
          </Box>
        </Section>
        <Box className={footer}>
          <PreFooter />
        </Box>
        <Backdrop open={submitting} className={loading}>
          <CircularProgress color='secondary' />
        </Backdrop>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => {
            setSnackbar((state) => ({ ...state, open: false }));
          }}
        >
          <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
        </Snackbar>
      </Container>
    </>
  );
};

export default ResetPassword;
